import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

const ErrorModal = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, error } = props;

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ minWidth: "40%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Lý do</Label>
        </ModalHeader>
        {/* {loading ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="0"
              countButton="2"
              formClass="row-cols-1 row-cols-md-1"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : ( */}
        <React.Fragment>
          <ModalBody>
            <Row className="font-size-14 mt-1">
              <Col>
                <div dangerouslySetInnerHTML={{ __html: error }}></div>
              </Col>
            </Row>
          </ModalBody>
        </React.Fragment>
        {/* )} */}
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  error: PropTypes.any,
};

export default ErrorModal;
